import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Footer from './Footer';

function PageWrapper({ children, className }) {
  return (
    <div className={className}>
      <Header />
      { children }
      <Footer />
    </div>
  );
}

PageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

PageWrapper.defaultProps = {
  className: '',
};

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js